
import React from 'react';
import { Button } from '@/components/ui/button';
import { Save, ChevronLeft } from 'lucide-react';
import { GamePlan } from '@/types/gamePlanner';
import { UnsavedChangesDialog } from './UnsavedChangesDialog';

interface EditorHeaderProps {
  currentPlan: GamePlan | null;
  onCancel: () => void;
  onSaveClick: () => void;
  isSaving: boolean;
  hasUnsavedChanges: boolean;
}

export function EditorHeader({ 
  currentPlan, 
  onCancel, 
  onSaveClick, 
  isSaving,
  hasUnsavedChanges
}: EditorHeaderProps) {
  const [showUnsavedDialog, setShowUnsavedDialog] = React.useState(false);

  const handleBackClick = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedDialog(true);
    } else {
      onCancel();
    }
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button variant="ghost" onClick={handleBackClick}>
            <ChevronLeft className="h-5 w-5 mr-2" />
            Back
          </Button>
          <h1 className="text-2xl font-bold">
            {currentPlan ? 
              currentPlan.is_template ? 
                `Create from Template: ${currentPlan.name}` : 
                `Edit: ${currentPlan.name}` 
              : 'Create Game Plan'}
          </h1>
        </div>
        <Button 
          variant="default" 
          onClick={onSaveClick}
          disabled={isSaving}
        >
          <Save className="mr-2 h-4 w-4" />
          Save
        </Button>
      </div>

      <UnsavedChangesDialog 
        open={showUnsavedDialog}
        onOpenChange={setShowUnsavedDialog}
        onConfirmExit={onCancel}
      />
    </>
  );
}
